import type { VideoPreview } from '../models/videoPreview'

export type ParsedYouTubePreviewMetadata = {
  songTitle: string
  artist: string
  presetBaseName: string
}

const suffixPatterns = [
  /\s*\((?:official\s+music\s+video|official\s+video|official\s+audio|lyrics?|lyric\s+video|audio)\)\s*$/i,
  /\s*\[(?:hd|4k|official)\]\s*$/i,
  /\s*\((?:live|remastered)[^)]*\)\s*$/i,
]

export function derivePresetBaseName(songTitle: string) {
  return songTitle.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 8)
}

export function parseYouTubePreviewMetadata(preview: VideoPreview): ParsedYouTubePreviewMetadata {
  const title = preview.title.trim()
  const parts = title.split(/\s+-\s+/)
  const hasArtistSongFormat = parts.length >= 2
  const artist = (hasArtistSongFormat ? cleanupText(parts[0]) : preview.channel.trim()) || preview.channel.trim()
  const songTitle = cleanupText(hasArtistSongFormat ? parts.slice(1).join(' - ') : title)

  return {
    songTitle,
    artist,
    presetBaseName: derivePresetBaseName(songTitle),
  }
}

function cleanupText(value: string) {
  let cleaned = value.trim()
  let previous = ''

  while (cleaned && cleaned !== previous) {
    previous = cleaned
    for (const pattern of suffixPatterns) {
      cleaned = cleaned.replace(pattern, '').trim()
    }
  }

  return cleaned.replace(/\s+/g, ' ').trim()
}
